<template>
  <main class="main-content">
    <div class="content-container">
      <chat-interface ref="chatInterface" />
    </div>
  </main>
</template>

<script>
import ChatInterface from '@/components/chat/ChatInterface.vue';

export default {
  name: 'MainContent',
  components: {
    ChatInterface
  }
}
</script>

<style scoped>
.main-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.content-container {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .content-container {
    padding: 0 10px;
  }
}
</style> 